import React from "react";
import "./Filters.css";
import "../components/styles/FiltersGlobal.css";
import FilterHeader from "../components/FilterHeader";
import Key from "../components/Key";
import Genre from "../components/Genre";
import Theme from "../components/Theme";
import Rythm from "../components/Rythm";
import MenuActions from "../components/MenuActions";

function Filters() {
  return (
    <div className="filtersContainer">
      <FilterHeader />
      <Key />
      <Genre />
      <Theme />
      <Rythm />
      <div className="spacer" style={{ flexGrow: 1 }}></div>
      <MenuActions />
    </div>
  );
}

export default Filters;
